import React from 'react';
import { AlertTriangle } from 'lucide-react';

// The gate in front of every Toolkit WRITE to a property's OPERA v5 database: a plain statement of what will change,
// and the project's name typed to confirm. The server checks the same text (toolkit index.js), so this is not only a
// screen-side guard. Superadmin only, as the writes are.

function ToolkitWriteConfirm({ project, what, value, onChange }) {
    const name = project?.projectName || '';
    const ok = value.trim().toLowerCase() === name.trim().toLowerCase() && !!name;
    return (
        <div className="tkb-write-confirm">
            <div className="tkb-write-head"><AlertTriangle size={16} /> This writes to the property's live OPERA v5 database</div>
            <p className="tkb-msg" style={{ margin: '0.3rem 0 0.6rem' }}>{what}</p>
            <label className="tkb-inline" style={{ marginTop: 0, maxWidth: 420 }}>
                <span>Type the project name — <strong>{name}</strong> — to allow it</span>
                <input type="text" value={value} onChange={(e) => onChange(e.target.value)} />
            </label>
            {value && !ok && <p className="tkb-hint">Not the project name yet.</p>}
        </div>
    );
}

export const confirmed = (project, value) => !!project?.projectName && value.trim().toLowerCase() === project.projectName.trim().toLowerCase();

export default ToolkitWriteConfirm;
